export default __webpack_public_path__ + "static/media/astronumerologie-repo.0e8a6b06.png";